export default __webpack_public_path__ + "static/imgScreen2_1400-30225ff7d90064d99674ae5f9d42247a.jpg";